export default __webpack_public_path__ + "static/media/037-magnifying glass.4ecb1d29.svg";